import { AuthorizationUpdated } from "event-definitions"
import { noChange } from "lib/@hooks/useRefresh"
import { checkPermission } from "library/authorization/index.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function useDemand(demand, and) {
    const { scopedDemands } = useBoundContext()
    AuthorizationUpdated.useRefresh(noChange)
    return checkPermission(demand, and, scopedDemands)
}
